module.exports = __webpack_public_path__ + "img/hmpg-yellowpage.7b7751d2.svg";